import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { ICON_SIZES } from './constants';
var transformIconProps = function transformIconProps(props) {
  var newProps = _objectSpread({}, props);
  var iconSize = props.size && ICON_SIZES[props.size];
  if (iconSize) {
    newProps.width = iconSize;
    newProps.height = iconSize;
  }
  return newProps;
};
export { transformIconProps };